import React from "react"
import L10n from "lib/carrot-l10n"
import Helpers from "utils/Helpers"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { useDispatch, useSelector } from "react-redux"
import { signOut } from "actions/loginActions"
import { Body } from "../atoms/Bodies"
import { FlexContainer, H2, Container } from "@carrotfertility/carotene"
import { Modal } from "./Modal"
import { IlloUnderwaterDesktop } from "../atoms/Illustrations"
import { getFirstName } from "../../../reducers/userInfo"
import { getBenefitStartDate, getBenefitStarted } from "../../../derivedSelectors"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const getApplicationNode = () => document.getElementById("body")

const BenefitNotStartedContainer = () => {
  const benefitStarted = useSelector(getBenefitStarted)
  const benefitStartDate = useSelector(getBenefitStartDate)
  const firstName = useSelector(getFirstName)

  return benefitStarted ? null : <BenefitNotStarted benefitStartDate={benefitStartDate} firstName={firstName} />
}

const BenefitNotStarted = ({ benefitStartDate, firstName }) => {
  const dispatch = useDispatch()

  const handleSignOutClick = () => {
    dispatch(signOut())
  }

  return (
    <Modal
      getApplicationNode={getApplicationNode}
      showCloseButton={false}
      titleText="Benefit not started"
      underlayClickExits={false}
      includeDefaultStyles={false}
      dialogClass="fixed top-0 left-0 w-100 h-100 z-9999 overflow-x-hidden overflow-y-auto flex justify-center items-center bg-benefit-started-modal"
      scrollDisabled
      focusDialog
    >
      <Container width="100%" paddingLeftRight="huge" paddingTopBottom="medium">
        <FlexContainer justifyContent="center" padding="large">
          <IlloUnderwaterDesktop className={null} />
        </FlexContainer>
        <H2 stack="tiny">{`You're all set for now, ${firstName}`}</H2>
        <Container stack="large">
          <Body>{`Your Carrot benefit begins on ${Helpers.formatDate(
            benefitStartDate,
            "MMMM DD, YYYY"
          )}. We look forward to seeing you then!`}</Body>
        </Container>

        <FlexContainer justifyContent={"flex-end"}>
          <ButtonPrimary onClick={handleSignOutClick}>Sign out</ButtonPrimary>
        </FlexContainer>
      </Container>
    </Modal>
  )
}

export { BenefitNotStartedContainer, BenefitNotStarted }
